import type { ReactElement, ReactNode } from 'react';
import Link from './Link';

type Props = {
  href: string;
  reload?: boolean;
  'data-cy'?: string;
  target?: string;
  rel?: string;
  children: ReactNode;
};

function SubLink({
  href,
  reload = false,
  'data-cy': dataCy = '',
  target,
  rel,
  children,
}: Props): ReactElement {
  return (
    <Link
      href={href}
      reload={reload}
      className="c-nav-header__sublink"
      data-cy={dataCy}
      target={target}
      rel={rel}
    >
      {children}
    </Link>
  );
}

export default SubLink;
